"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignClient = void 0;
const core_1 = require("@okxconnect/core");
const namespaces_1 = require("../utils/namespaces");
const ConnectMethodUtils_1 = require("../utils/ConnectMethodUtils");
const constants_1 = require("../../provider/constants");
class SignClient extends core_1.ISignClient {
    constructor(metaData, events, openAppLineType) {
        super(metaData);
        // ---------- Engine ----------------------------------------------- //
        this.connect = (params) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    var connectRequest = [];
                    (0, core_1.logDebug)(`client connect params >>>`, JSON.stringify(params));
                    var requestAccountItem = {
                        name: "requestAccounts",
                        requiredNamespaces: (0, namespaces_1.nameSpaceToConnectWalletNameSpace)(params.namespaces),
                        optionalNamespaces: (0, namespaces_1.nameSpaceToConnectWalletNameSpace)(params.optionalNamespaces),
                    };
                    this.engine.setSessionConnectingListener(() => {
                        (0, core_1.logDebug)(`sessionConnectingListener >>>`);
                        this.events.emit(constants_1.PROVIDER_EVENTS.SESSION_CONNECTING);
                    });
                    if (params.signRequest) {
                        requestAccountItem.connectRequestMethods = yield (0, ConnectMethodUtils_1.connectMethodsToConnectWalletMethods)(params.signRequest, requestAccountItem.requiredNamespaces);
                    }
                    connectRequest.push(requestAccountItem);
                    (0, core_1.logDebug)(`client connect connectRequest >>>`, JSON.stringify(connectRequest));
                    this.engine.universalConnect(connectRequest, Object.assign({ dappInfo: this.metadata }, params.sessionConfig), (info) => {
                        if (info && info.connectRequest) {
                            (0, core_1.logDebug)(`universalConect info.connectRequest :`, info.connectRequest);
                            (0, core_1.logDebug)(`universalConect url:`, (0, core_1.getOKXLink)(info.connectRequest, this.sessionConfig.useMini));
                            this.events.emit("display_uri", (0, core_1.getOKXLink)(info.connectRequest, this.sessionConfig.useMini).universalLink);
                            this.events.emit("short_display_uri", (0, core_1.getAppWalletShortDeepLink)(info.connectRequest.topic, info.connectRequest.clientId));
                            (0, core_1.logDebug)(`universalConect EngineConnectInfo  ${JSON.stringify(info)}`);
                            this.events.emit("okx_engine_connect_params", info);
                        }
                    }).then((session) => __awaiter(this, void 0, void 0, function* () {
                        (0, namespaces_1.fillParamsToSession)(session, params.namespaces, params.optionalNamespaces, this.sessionConfig);
                        (0, core_1.logDebug)(`signClient: connect: session ${JSON.stringify(session)}`);
                        if (params.signRequest) {
                            yield (0, ConnectMethodUtils_1.connectMethodsResponseUpdate)(session, params.signRequest);
                        }
                        resolve(session);
                    })).catch((e) => {
                        (0, core_1.logDebug)(`signClient: connect: catch ${JSON.stringify(e)}`);
                        this.events.emit("connect_error", e);
                        reject(e);
                    });
                }
                catch (error) {
                    (0, core_1.logDebug)(`signClient: connect:  ${JSON.stringify(error)}`);
                    reject(error);
                }
            }));
        });
        this.restoreconnect = (sessionConfig) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.engine.restoreconnect(sessionConfig, (session) => {
                    if (session) {
                        resolve(session);
                    }
                    else {
                        reject();
                    }
                });
            });
        });
        this.reject = (params) => __awaiter(this, void 0, void 0, function* () {
        });
        this.request = (params) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                (0, core_1.logDebug)("clint request --params>>>> >", (_a = this.sessionConfig) === null || _a === void 0 ? void 0 : _a.openUniversalUrl, (0, core_1.safeJsonStringify)(params));
                try {
                    // this.sessionConfig
                    if (((_b = this.sessionConfig) === null || _b === void 0 ? void 0 : _b.openUniversalUrl) && (0, core_1.isIos)()) {
                        this.openOKXWallet();
                    }
                    yield this.engine.send(params, {
                        resolve: (response) => {
                            delete response.requestId;
                            (0, core_1.logDebug)("clint request --response >", (0, core_1.safeJsonStringify)(response));
                            if (('error' in response) && response.error) {
                                let error = response.error;
                                reject(new core_1.OKXConnectError(response.error.code, response.method + ":" + error.message));
                            }
                            else {
                                resolve(response);
                            }
                        },
                        onAck: () => {
                            var _a;
                            if (!(0, core_1.isIos)() && ((_a = this.sessionConfig) === null || _a === void 0 ? void 0 : _a.openUniversalUrl)) {
                                this.openOKXWallet();
                            }
                        }
                    });
                }
                catch (e) {
                    (0, core_1.logDebug)("clint request --error:", e);
                    reject(e);
                }
            }));
        });
        this.disconnect = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.engine.send({
                    method: "disconnect"
                }, {
                    onAck: () => {
                        resolve();
                    }
                }, 86400000).catch((error) => {
                    console.log(`disconnect : ${JSON.stringify(error)}`);
                    reject(error);
                });
            });
        });
        this.engine = new core_1.Engine(metaData.name);
        this.events = events;
        this.metadata = metaData;
        this.openAppLineType = openAppLineType !== null && openAppLineType !== void 0 ? openAppLineType : core_1.OpenAppLinkType.UniversalLink;
    }
    setAccountChangeListener(accountChangeListener) {
        this.engine.setAccountChangeListener(accountChangeListener);
    }
    openOKXWallet() {
        // if (this.openUniversalUrl){
        (0, core_1.logDebug)('bridge-provider ==>> connect_5');
        this.engine.openWallet({ tmaReturnUrl: this.sessionConfig.tmaReturnUrl }, null, this.openAppLineType);
        // if (this.sessionConfig?.useMini){
        //     let url = getTelegramWalletTWAUrl(undefined,this.sessionConfig.tmaReturnUrl)
        //     openOKXTMAWalletlinkWithFallback(url)
        // }else{
        //     openOKXDeeplink(standardDeeplink);
        // }
        // }
    }
    syncAllAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.engine.send({
                    method: "sync_all_addresses"
                }, {
                    resolve: (response) => {
                        delete response.requestId;
                        (0, core_1.logDebug)("clint syncAllAddress --response >", JSON.stringify(response));
                        if (('error' in response) && response.error) {
                            let error = response.error;
                            reject(new core_1.OKXConnectError(response.error.code, response.method + ":" + error.message));
                        }
                        else {
                            let allAddressStr = response.result;
                            resolve((0, ConnectMethodUtils_1.syncResoonseToRequire)(allAddressStr));
                        }
                    }
                }).catch((error) => {
                    console.log(`disconnect : ${JSON.stringify(error)}`);
                    reject(error);
                });
            });
        });
    }
    registerConnector(connectors) {
        this.engine.registerConnector(connectors);
    }
    openWallet(engineConnectInfo, connector) {
        this.engine.openWallet(engineConnectInfo, connector, this.openAppLineType);
    }
    setConnectConnector(wallet) {
        this.engine.setConnectConnector(wallet);
    }
    needCheckRequestMethod() {
        try {
            return !Object.values(core_1.CONNECTOR_TYPE.INJECT).includes(this.engine.getConnector().getType())
                && !Object.values(core_1.CONNECTOR_TYPE.KEYLESS).includes(this.engine.getConnector().getType());
        }
        catch (error) {
            return true;
        }
    }
}
exports.SignClient = SignClient;
